import React, { useMemo, useEffect, useState } from "react";
import {
  Calendar,
  Views,
  dateFnsLocalizer,
  momentLocalizer,
} from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import enUS from "date-fns/locale/en-US";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Grid } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux/store";
import { getEventList } from "redux/slices/Events";
import moment from "moment";
import { EventWrapper, Event } from "./EventWraper";
import Menu from "components/menu/MainMenu";
import { useHistory, useLocation } from "react-router-dom";
import { useEvents } from "../hooks";
import { Spin } from "antd";

var newDateObj = moment(new Date("2023-05-29")).add(30, "m").toDate();
const locales = {
  "en-US": enUS,
};
const events = [
  {
    id: 0,
    title: "Some Event",
    start: new Date(),
    end: newDateObj,
  },
  // {
  //   id: 1,
  //   title: "Some Event",
  //   start: new Date( ),
  //   end: new Date( ),
  // },
  {
    id: 4,
    title: "Some Event",
    start: new Date(2023, 3, 28, 3, 0, 0),
    end: new Date(2023, 3, 28, 5, 0, 0),
  },
];
interface Props {
  onOpen: Function;
  onEditEvent: Function;
}

export default function Timeslots(props: any) {
  const { userId, selectedLocation } = useSelector((state: any) => state.Auth);
  const history = useHistory();
  

  const { onOpen, onEditEvent, data ,isFetching } = props;
  const dispatch: AppDispatch = useDispatch();
  const defaultDate = useMemo(() => new Date(), []);
  const { eventList } = useSelector((state: any) => state.Events);
  const [eventListArr, setEventListArr] = useState([]);

  

  useEffect(() => {
    if (data?.response?.tournaments.length) {
      let list = data.response?.tournaments.map((x: any) => {
        return {
          ...x,
          id: x.tournamentId,
          title: x.name,
          start: moment(x.startDate + " " + x.startTime).toDate(),
          end: moment(x.startDate + " " + x.endTime).toDate(),
        };
      });
      // console.log({ list });
      setEventListArr(list);
      // console.log({ eventList, events });
    }
  }, [data]);
  const localizer = momentLocalizer(moment);
  const eventRenderProps = (
    event: any,
    start: any,
    end: any,
    isSelected: any
  ) => {
    let result = {
      style: {
        backgroundColor: "#DBE9FF",
        color: "black",
        borderRadius: 0,
        border: "0px",
        borderLeft: "4px solid #1E75FF",
        minHeight: "70px",
        borderTopRightRadius: "8px",
      },
    };
    // Code to conditionally add 'className' or 'style' to the result
    return result; // {className?: String, style?: Object}
  };
  const navigateToEventDetail = (e: any) => {
    console.log({ e });
    history.push({
      pathname: "/admin/BracketPortal",
      state: { eventDetail: e },
      search: `?eventId=${e.id}`,
    });

    // history.push({
    //   pathname: "/admin/ViewHubDetails",
    //   search: `?hubId=${hubId.row.original.userId}`,
    // });
  };

  return (
    <Spin spinning={isFetching} tip="Fetching Events...">
    <Grid bg="white" h={"1800px"} p="20px" borderRadius={"20px"}>
      
      <Calendar
        selectable={true}
        onSelectSlot={(SlotInfo) => onOpen()}
        // onSelecting={()=>onOpen()}
        startAccessor="start"
        endAccessor="end"
        // onKeyPressEvent={alert}
        onSelectEvent={(e) => navigateToEventDetail(e)}
        // onSelecting={alert}
        eventPropGetter={eventRenderProps}
        components={{
          event: Event,
          eventWrapper: (props: any) =>
            EventWrapper({ ...props, onEditEvent: onEditEvent }),
        }}
        defaultDate={defaultDate}
        defaultView={Views.WEEK}
        events={eventListArr.length ? eventListArr : events}
        // events={[]}

        localizer={localizer}
        step={60}
        timeslots={1}
      />
    
    </Grid>
    </Spin>
  );
}
